<div class="hidden print-flex  justify-center -mt-2 mb-3">@if (!isBluebird) {
  <img class="h-14"
    src="/assets/logo.png" />
  }@if (isBluebird) {
  <img class="h-12" src="/assets/bluebirdlogo.png" />
}</div>
<div class="primary-green-border rounded-lg p-4 mb-4 lg:mx-4 print-no-margin"
  [ngClass]="statusBorderClass()">
  @if (auditResultDetail.AuditID == -1) {
    <div>
      <h2>Loading...</h2>
    </div>
  }
  @if (auditResultDetail.AuditID != -1) {
    <div>
      <div class="flex justify-between">
        <div>
          <h2>{{auditResultDetail.AuditName}} <h4><span
          class="text-green-300 h5span">&#64;</span>{{auditResultDetail.Location.LocationName}}</h4>
        </h2>
      </div>
      @if (showScore()) {
        <div>
          <h2>{{calcPercent()}}%</h2>
          <p class="text-right pr-2">{{auditResultDetail.Score}}/{{auditResultDetail.MaxScore}}</p>
        </div>
      }
    </div>
    <div class="mt-4 mx-2  justify-between hidden lg:flex print-hidden">
      <h4>Completed: {{humanDate(auditResultDetail.SubmittedDate)}} <span
      class="text-green-300 font-bold h4span">by</span> {{auditResultDetail.UserCreatedName}}</h4>
      <h4 class="">Outstanding Actions: <span class="h4span">{{auditResultDetail.TotalOutstandingActions}}</span>
      @if (overdueActions()>0) {
        <span class="h4span"> <strong class="text-danger-base ml-2">({{overdueActions()}}
        overdue)</strong> </span>
      }</h4>
    </div>
    <div class="mt-4 mx-2  flex flex-col lg:hidden  print-hidden">
      <h4>Completed: {{humanDate(auditResultDetail.SubmittedDate)}}</h4>
      <h4> <span class="text-green-300 font-bold h4span">by</span> {{auditResultDetail.UserCreatedName}}</h4>
      <h4 class="">Outstanding Actions: <span class="h4span">{{auditResultDetail.TotalOutstandingActions}}</span>
      @if (overdueActions()>0) {
        <span class="h4span"> <strong class="text-danger-base ml-2">({{overdueActions()}}
        overdue)</strong> </span>
      }</h4>
    </div>
    <div class="justify-between hidden print-flex">
      <h4>Completed: {{humanDate(auditResultDetail.SubmittedDate)}} <span
      class="text-green-300 font-bold h4span">by</span> {{auditResultDetail.UserCreatedName}}</h4>
      @if (auditResultDetail.TotalOutstandingActions == 0) {
        <p>No outstanding actions</p>
      }
      @if (auditResultDetail.TotalOutstandingActions > 0) {
        <div class="border-offblack border-2 p-3">
          <p class="font-bold">{{auditResultDetail.TotalOutstandingActions}} Outstanding Action@if (auditResultDetail.TotalOutstandingActions > 1) {
            <span>s</span>
          }</p>
        </div>
      }
    </div>
    @if (!showQuestionsAccordion) {
      <h3 class="my-5 print-mb-1 ">Questions</h3>
      @for (q of auditResultDetail.Questions; track q) {
        <div>
          <app-audit-result-detail-question [question]="q" [eventId]="eventId"></app-audit-result-detail-question>
        </div>
      }
    }
    @if (showQuestionsAccordion) {
      <div class="mt-4">
        <button class="btn-inverse btn-compact" type="button" (click)="toggleQuestions()">
          <i class="pi" [ngClass]="questionsCollapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
          <span class="ml-1">{{questionsCollapsed ? 'Show questions' : 'Hide questions'}}</span>
        </button>
        @if (!questionsCollapsed) {
          <div class="mt-3">
            <h3 class="mb-3">Questions</h3>
            @for (q of auditResultDetail.Questions; track q) {
              <div class="mb-2">
                <app-audit-result-detail-question [question]="q" [eventId]="eventId"></app-audit-result-detail-question>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
</div>
